<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="backList">用户管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>代理信息</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns1">
        <li>
          <el-button
            @click="backList"
            type="primary"
          >返回代理列表</el-button>
        </li>
      </ul>
      <div class="contain_header1 clr">
        <el-form
          style="width:850px;"
          ref="form"
          :model="form"
          label-width="200px"
          :rules="addFormRule"
        >

          <el-form-item
            label="昵称"
            prop="username"
          >
            <el-input
              v-model="form.username"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="手机号"
            prop="telephone"
          >
            <el-input
              :disabled="form.openStatus > 1"
              v-model="form.telephone"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item

            label="真实姓名"
            prop="realName"
          >
            <el-input
              :disabled="form.openStatus > 2"
              v-model="form.realName"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.role_type > -1"
            label="特殊身份"
            prop="special_status"
          >
            <el-select
              v-model="form.special_status"
              placeholder="请选择"
            >
              <el-option
                v-for="option in specialOptions"
                :value="option.value"
                :key='option.value'
                :label="option.text"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="联盟店类型" prop="provinceType" v-show="form.role_type == 1">
            <el-select v-model="form.provinceType" placeholder="请选择">
              <el-option
                v-for="option in provinceTypeOptions"
                :value="option.value"
                :key="option.value"
                :label="option.text"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否是束轩" prop="suType" v-show="form.role_type == 0 || form.role_type == 1 || form.role_type == 1.05">
            <el-select v-model="form.suType" placeholder="请选择">
              <el-option
                v-for="option in suOptions"
                :value="option.value"
                :key="option.value"
                :label="option.text"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item

            label="身份证号"
            prop="idCode"
          >
            <el-input
              :disabled="form.openStatus > 2"
              v-model="form.idCode"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="店铺名称"
            prop="showName"
             v-if="form.role_type > -1"
          >
            <el-input
              v-model="form.showName"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.id == null"
            label="余额"
            prop="balance"
          >
            <el-input
              oninput ="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.balance"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="保证金"
            prop="deposit"
            v-if="form.id == null"
          >
            <el-input
              oninput ="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.deposit"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="性别"
            prop="sex"
          >
            <el-select
              v-model="form.sex"
              placeholder="请选择"
            >
              <el-option
                v-for="option in sexOptions"
                :value="option.value"
                :key='option.value'
                :label="option.text"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="上级推荐码"
            prop="recommendCode"
            v-if="form.id == null"
          >
            <el-input
              v-model="form.recommendCode"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="代理类型"
            prop="roleType"
            v-if="form.id == null"
          >
            <el-select
              v-model="form.roleType"
              placeholder="请选择"
            >
              <el-option
                v-for="option in typeOptions"
                :value="option.value"
                :key='option.value'
                :label="option.text"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="所在省"
            prop="province"
             v-if="form.role_type > -1"
          >
            <el-select
              v-model="form.province"
              placeholder="请选择"
              @change="changeCity"
            >
              <el-option
                v-for="option in provinceOptions"
                :value="option"
                :key='option'
                :label="option"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="所在市"
            prop="city"
             v-if="form.role_type > -1"
          >
            <el-select
              v-model="form.city"
              placeholder="请选择"
              @change="changeDistrict"
            >
              <el-option
                v-for="option in cityOptions"
                :value="option"
                :key='option'
                :label="option"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="所在区"
            prop="district"
             v-if="form.role_type > -1"
          >
            <el-select
              v-model="form.district"
              placeholder="请选择"
            >
              <el-option
                v-for="option in districtOption"
                :value="option"
                :key='option'
                :label="option"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="头像"
            prop="userHead"
          >
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data='tokenData'
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="form.userHead"
                :src="form.userHead"
                class="avatar"
              >
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
              <div
                slot="tip"
                class="el-upload__tip"
              >只能上传jpg/png文件，图片比例：375px*210px</div>
            </el-upload>
          </el-form-item>

          <div style="display:flex;" v-if="form.role_type > -1">

            <el-form-item
              label="门店地址"
              prop="longitude"
            >
              <el-input
                id='tipinput'
                v-model="form.addressDetail"
              ></el-input>

              <div
                class="amap-wrapper2"
                id="container"
                tabindex="0"
              >

              </div>
            </el-form-item>

            <div style="margin-left:20px;">
              <el-button
                :loading="searchAddByWordLoading"
                @click="searchAddByWord"
                size="small"
                type="primary"
              >搜索</el-button>
              <div style="margin-top: 5px;height: 500px;overflow-y: auto;">
                <div v-bind:class="{choosedLi:showItemIndex==index}" @click="showItem(item, index)" v-for="(item, index) in searchList" v-bind:key="index" style="width:250px;padding:10px 5px;display:flex;flex-direction: column;cursor: pointer;">
                  <span>地址信息：{{item.formatted_address}}</span>
                  <span>坐标：{{item.location}}</span>
                  <span>省市：{{item.country}}{{item.city}}{{item.district}}</span>
                </div>
              </div>
            </div>
          </div>


          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('form')"
              :loading="addLoading"
            >{{wordName}}</el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>

  </el-main>
</template>

<script>
import AMap from "AMap";
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc.js";
var _ = require("lodash");
export default {
  name: "editNormalUser",
  data() {
    return {
      searchList:[],
      showItemIndex:null,
      searchAddByWordLoading:false,
      options: [{ text: "显示", value: "1" }, { text: "不显示", value: "0" }],
      sexOptions: [{ text: "男", value: "1" }, { text: "女", value: "2" }],
      typeOptions: [{ text: "康减系列vip会员", value: "-0.5" }, { text: "康减系列高级会员", value: "-0.4" }, { text: "康减系列荣誉会员", value: "-0.3" },{ text: "康减系列市代", value: "1.1" },{ text: "优秀联盟店", value: "1.05" }, { text: "康减系列省代", value: "2.1" }, { text: "康减系列CEO", value: "3.1" },{ text: "VIP门店", value: "0" },{ text: "联盟店", value: "1" },{ text: "市代", value: "2" },{ text: "省代", value: "3" },{ text: "CEO", value: "4" },{ text: "合伙人", value: "2.2" },{ text: "董事", value: "4.2" },{ text: "经销商", value: "4.8" },{ text: "区域总监", value: "5.1" },{ text: "城市加盟商", value: "5.2" }],
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      good: null,
      provinceOptions: [],
      wordName: "新增",
      suOptions: [
        { text: "不是", value: "2" },
        { text: "是", value: "1" }
      ],
      specialOptions: [{ text: "不是", value: "1" }, { text: "是", value: "2" }],
      addFormRule: {
        username: [{ required: true, message: "请填写昵称", trigger: "blur" }],
        sex: [
          { required: true, message: "请选择性别", trigger: "blur" }
        ]
      },
      addLoading: false,
      cityOptions: [],
      districtOption: [],provinceTypeOptions: [
        { text: "全部", value: "3" },
        { text: "康减康庭系列联盟店", value: "4" },
        { text: "康颜单项联盟店", value: "5" }
      ],
      form: {
        showName:null,
        suType:null,
        role_type:null,
        special_status:null,
        provinceType:null,
        username: null,
        telephone: null,
        realName: null,
        idFront: null,
        id: null,
        idBack: null,
        idCode: null,
        openStatus:null,
        addressDetail:null,
        province: null,
        city: null,
        district: null,
        userHead: 'https://vedio.hkymr.com/kefuPic.png',
        balance: null,
        deposit: null,
        roleType: null,
        sex: null,
        recommendCode: null
      }
    };
  },
  mounted(e) {
    //初始化表单
    var that = this;
    this.loadmap();
    API.get_province({ token: localStorage.getItem("api_token") })
      .then(
        function(result) {
          if (result.key == 1000) {
            that.provinceOptions = result.result.list;
            that.changeCity(1);
          } else if (result.key == 1001) {
            bus.$emit("goto", "/login");
          } else {
            that.$message.error({
              showClose: true,
              message: result.message || "登录失败",
              duration: 2000
            });
          }
        },
        function(err) {
          console.error(err);
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        console.error(error);
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    var good = this.$route.query.good;
    that.good = good;
    var para = {
      id: that.$route.query.id,
      token: localStorage.getItem("api_token")
    };
    if (good != null) {
      that.wordName = "修改";
      that.form.id = good.id;
      this.form.special_status = good.special_status.toString();
      this.form.suType = good.su_type.toString();
      this.form.provinceType = good.province_type == null ? null : good.province_type.toString();
      that.form.realName = good.real_name;
      that.form.username = good.username;
      that.form.telephone = good.telephone;
      that.form.province = good.province;
      that.form.addressDetail = good.shop_detail;
      that.form.city = good.city;
      that.form.district = good.district;
      that.form.showName = good.show_name;
      that.form.sex = good.sex.toString();
      that.form.role_type = good.role_type;
      that.form.userHead = good.user_head;
      that.form.idBack = good.id_back_pic;
      that.form.idFront = good.id_front_pic;
      that.form.idCode = good.id_code;
      that.form.openStatus = good.open_status;
that.form.user_type = good.user_type;

      if (good.longitude != null)
      {
        var lng = good.longitude;
        var lat = good.latitude;
        if (this.marker != null) {
          this.marker.setMap(null);
          this.marker = null;
        }
        // console.info(e);
        this.marker = new AMap.Marker({
          // icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
          position: [lng, lat],
          offset: new AMap.Pixel(-13, -30),
          clickable: true
        });
        this.marker.setMap(this.map);
        var lng = lng; //经度范围[121.138398, 121.728226]
        var lat = lat; //纬度范围[30.972688, 31.487611]
        this.map.setCenter([lng, lat]); //设置地图中心点
        var clickHandle = AMap.event.addListener(this.marker, "click", function(
          e
        ) {
        });
        this.form.latitude = lat;
        this.form.longitude = lng;
      }
    } else {
      that.form.info_type = '1';
      that.wordName = "立即创建";
    }
  },
  computed: {},
  methods: {
    changeCity(first) {
      if (this.form.province != null) {
        var that = this;
        API.get_city({
          token: localStorage.getItem("api_token"),
          province: this.form.province
        })
          .then(
            function(result) {
              if (result.key == 1000) {
                that.cityOptions = result.result.list;
                if (that.form.province != that.good.province)
                {
                  that.form.city = null;
                  that.form.district = null;
                } else {
                  that.form.city = that.good.city;
                  that.form.district = that.good.district;
                }
                if (first && first != null)
                {
                  that.changeDistrict();
                }
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.message || "登录失败",
                  duration: 2000
                });
              }
            },
            function(err) {
              console.error(err);
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            console.error(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    changeDistrict() {
      if (this.form.city != null) {
        if (this.form.city != null) {
          this.auto.setCity(this.form.city);
        }
        // var auto = new AMap.Autocomplete(options);

        // var placeSearch = new AMap.PlaceSearch({
        //   map: this.map
        // }); //构造地点查询类
        // AMap.event.addListener(auto, "select", this.select); //注册监听，当选中某条记录时会触发
        var that = this;
        API.get_district({
          token: localStorage.getItem("api_token"),
          city: this.form.city
        })
          .then(
            function(result) {
              if (result.key == 1000) {
                that.districtOption = result.result.list;
                if (that.form.city != that.good.city)
                {
                  that.form.district = null;
                } else
                {
                  that.form.district = that.good.district;
                }
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.message || "登录失败",
                  duration: 2000
                });
              }
            },
            function(err) {
              console.error(err);
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            console.error(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      }
    },
    showItem(item, index){
      this.showItemIndex = index;
      var loc = item.location.split(',');
      var lng = loc[0];
      var lat = loc[1];
      if (this.marker != null) {
        this.marker.setMap(null);
        this.marker = null;
      }
      // console.info(e);
      this.marker = new AMap.Marker({
        // icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
        position: [lng, lat],
        offset: new AMap.Pixel(-13, -30),
        clickable: true
      });
      this.marker.setMap(this.map);
      var lng = lng; //经度范围[121.138398, 121.728226]
      var lat = lat; //纬度范围[30.972688, 31.487611]
      this.map.setCenter([lng, lat]); //设置地图中心点
      var clickHandle = AMap.event.addListener(this.marker, "click", function(
        e
      ) {
      });
      this.form.latitude = lat;
      this.form.longitude = lng;
    },
    searchAddByWord() {
      if (this.form.addressDetail != null && this.form.city != null) {
        var that = this;
        that.searchAddByWordLoading = true;
        API.select_address_by_word({
          token: localStorage.getItem("api_token"),
          word: this.form.addressDetail,
          city: this.form.city
        })
          .then(
            function(result) {
              if (result.key == 1000) {
                that.searchList = result.result.list;
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.message || "登录失败",
                  duration: 2000
                });
              }
              that.searchAddByWordLoading = false;
            },
            function(err) {
              that.searchAddByWordLoading = false;
              console.error(err);
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.searchAddByWordLoading = false;
            console.error(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      } else {
        this.$message.error({
          showClose: true,
          message: "请选择所在城市和填写要搜索的地址",
          duration: 2000
        });
      }
    },
    loadmap() {
      this.map = new AMap.Map("container", {
        zoom: 9
      });
      var options = {
        input: "tipinput"
      };
      if (this.form.city != null) {
        options.city = this.form.city;
      }
      this.auto = new AMap.Autocomplete(options);
      var placeSearch = new AMap.PlaceSearch({
        map: this.map
      }); //构造地点查询类
      AMap.event.addListener(this.auto, "select", this.select); //注册监听，当选中某条记录时会触发
    },
    beforeAvatarUpload: function(e) {},
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.userHead = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess1: function(e) {
      if (e.key == 1000) {
        this.form.idFront = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess2: function(e) {
      if (e.key == 1000) {
        this.form.idBack = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    backList() {
      this.$router.push({
        path: "/normal_user_list"
      });
    },

    onSubmit() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          that.addLoading = true;
          API.add_edit_app_user(para)
            .then(
              function(result) {
                that.addLoading = false;
                if (result.key == 1000) {
                  if (para.id) {
                    that.$message.success({
                      showClose: true,
                      message: "修改成功",
                      duration: 1500
                    });
                  } else {
                    that.$message.success({
                      showClose: true,
                      message: "创建成功",
                      duration: 1500
                    });
                  }
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    jumpTo(url) {
      this.defaultActiveIndex = url;
      this.$router.push(url); //用go刷新
    },
    resetForm() {
      let that = this;
      that.$refs["form"].resetFields();
    }
  }
};
</script>

<style>
.choosedLi{
  background-color: coral
}
.amap-wrapper2 {
  width: 600px;
  height: 500px;
}
.area-select .area-selected-trigger {
  padding: 0px 20px 7px 12px;
  line-height: 40px;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}
.cont_btns1 {
  float: left;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns1 li {
  display: inline-block;
}
.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}

.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}

.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}

.contain_div {
  margin: 20px;
}

.contain_header1 {
  background-color: #fff;
  padding: 40px 0 20px 40px;
  /* margin-bottom: 20px; */
}

.area-select {
  height: 40px;
}

.area-select-wrap .area-select {
  margin-left: 0px !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/user/editNormalUser.vue